/**
 * Contact / walkthrough request configuration.
 *
 * SALES_EMAIL is the shared box. Every commercial CTA on the site routes here so
 * that inbound is monitored by the team rather than one person's inbox — a lead
 * that lands in a personal inbox is a lead nobody else can pick up.
 *
 * FOUNDER_EMAIL is deliberately separate and used in exactly one place: the
 * founder note on /about, which ends "I'd want to hear about it — Mike". Routing
 * that to a shared box would defeat the point of making it personal.
 */
export const SALES_EMAIL = 'sales@ormal.io';
export const FOUNDER_EMAIL = 'mike@ormal.io';

/** @deprecated Use SALES_EMAIL. Kept so existing imports keep compiling. */
export const DEMO_REQUEST_EMAIL = SALES_EMAIL;

export const DEMO_REQUEST_MAILTO = `mailto:${SALES_EMAIL}?subject=Request%20Demo%20-%20Ormal`;
export const INTEREST_LIST_MAILTO = `mailto:${SALES_EMAIL}?subject=Join%20Interest%20List%20-%20Ormal`;
export const DESIGN_PARTNER_MAILTO = `mailto:${SALES_EMAIL}?subject=Design%20Partner%20Interest%20-%20Ormal`;
export const PLATFORM_WALKTHROUGH_MAILTO = `mailto:${SALES_EMAIL}?subject=Platform%20Walkthrough%20-%20Ormal`;
export const HEALTH_CHECK_MAILTO = `mailto:${SALES_EMAIL}?subject=Payment%20Health%20Check%20-%20Ormal`;
export const FOUNDER_MAILTO = `mailto:${FOUNDER_EMAIL}?subject=Hello%20from%20ormal.io`;
